<template>
    <div class="p-3">
        <h3>Pencarian Master ICD 9</h3>
        <hr>

        <div class="row mt-3">
            <h4 class="mb-3">Pencarian Data</h4>
            
            <div class="col-sm-3">
                <div class="mb-6 row">
                    <label for="search" class="col-sm-6 col-form-label text-end">Kode/Nama ICD 9</label>
                    <div class="col-sm-6">
                        <input type="text" name="search" id="search" class="form-control" v-model="filter.search">
                    </div>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="mb-3">
                    <div class="col-sm-8 text-end">
                        <button class="btn btn-danger" @click="resetFilters"><i class="fa fa-refresh"></i> Reset</button>
                        <button class="btn btn-primary" @click="getAllICD9"><i class="fa fa-search"></i> Cari</button>
                    </div>
                </div>
            </div>

            <div class="col-sm-2">
                <div class="mb-3">
                    <div class="col-sm-8 text-end">
                        <button class="btn btn-success" @click="tambahICD9"><i class="fa fa-plus"></i> Tambah</button>
                    </div>
                </div>
            </div>
            
        </div>
        <hr/>

        <div class="card mb-3">
            <div class="card-header text-white bg-primary">Data Master ICD 9</div>
            <div class="card-body">
                <div id="table-icd9"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { TabulatorFull as Tabulator } from 'tabulator-tables'

export default{
    data(){
        return {
            filter: {
                search: '',
            },
            data_icd9: []
        }
    },
    created() {
        this.filter.page = this.$route.query.page ?? 1
    },
    mounted(){
        this.getAllICD9()
    },
    methods: {
        getAllICD9(){
            const uri = `/api/master-icd9/get-all-icd9?search=${this.filter.search}`
            
            const element = document.getElementById('table-icd9')

            this.table = new Tabulator(element, {
                layout: 'fitColumns',
                pagination: 'true',
                paginationMode: 'remote',
                paginationSize: 10,
                paginationSizeSelector:[10, 25, 50, 100, true],
                dataLoader: this.ajaxLoader,
                ajaxURL: uri,
                ajaxResponse: this.AjaxResponse,
                sortMode: 'remote',
                filterMode: 'remote',

                columns: [
                    {title: 'Kode ICD 9', field: 'KDICD'},
                    {title: 'Nama ICD 9', field: 'Diagnosa'},
                    {title: 'Sub Kode ICD 9', field: 'KDDTD'},
                    {title: 'Action', formatter: function () {
                        return '<button class="btn btn-sm btn-primary" id="detail">Edit</button><button class="btn btn-sm btn-danger" id="delete">Delete</button>'
                    }, cellClick: this.rowActions},
                ]
            })
        },
        rowActions(e, cell) {
            const id = e.target.id
            switch (id) {
                case 'detail':
                    this.openDetailPage(cell)
                    break
                case 'delete':
                    this.konfirmDeleteICD9(cell)
                    break
            
                default:
                    break
            }
        },
        AjaxResponse(url, params, response) {
            return response.masteICD9
        },
        openDetailPage(cell) {
            const data = cell.getRow().getData()
            const KDICD = data.KDICD

            this.$router.push({
                name: 'updateICD9',
                params: { KDICD: KDICD}
            })
        },
        konfirmDeleteICD9(cell) {
            const data = cell.getRow().getData()
            this.$swal.fire({
                title: "Yakin?",
                text: "data akan dihapus!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Hapus"
            }).then((result) => {
                if (result.isConfirmed) {
                    this.deleteICD9(data)
                }
            })
        },
        deleteICD9(dataICD9) {
            const uri = '/api/master-icd9/delete-icd9'
            const data = {
                KDICD: dataICD9.KDICD
            }

            this.axios.post(uri, data).then(response => {
                if (response.data.status == 'success') {
                    this.$swal.fire({
                        title: "Berhasil!",
                        text: "Data Berhasil Dihapus",
                        icon: "success"
                    });
                    this.getAllICD9()
                } else {
                    this.$swal.fire({
                        title: "Gagal!",
                        text: response.data.message ?? 'Data Gagal Dihapus',
                        icon: "error"
                    });
                }
            })
        },
        resetFilters(){
            this.filter = {
                search: '',
                page: 1,
            }

            this.getAllICD9()
        },
        tambahICD9()
        {

            this.$router.push({
                name: 'tambahICD9',
            })
        }
    }
}
</script>